import { theme } from '@features/lci-report/domain/theme';
import {
  Slide,
  TextProps,
  TextPropsOptions,
  TextPropsTextConfig,
  ZERO_WIDTH_SPACE,
} from '@features/powerpoint';

export const emptyLine: TextPropsTextConfig = {
  text: ZERO_WIDTH_SPACE,
  options: { breakLine: true },
};

export const householdsText: TextPropsTextConfig = {
  text: '**HH = House Holds / M = Millions',
  options: { breakLine: true },
};

export const sharedNotesText: TextPropsTextConfig[] = [
  {
    text: '*Note: Feasibility assessment required by InMarket Measurement Team to request waiver of required minimum campaign impressions.',
    options: { breakLine: true },
  },
  emptyLine,
  householdsText,
];

export const campaignFlightNoteText: TextPropsTextConfig = {
  text: '**Minimum Campaign Flight = 2 weeks / Minimum Locations Needed for Measurement = 20 Locations',
};

export const notesOptions: TextPropsOptions = {
  fontSize: 10,
  color: theme.colors.white,
};

type NotesProps = {
  text: TextProps['text'];
  options?: TextPropsOptions;
};

export const notes = (props: NotesProps): Slide => {
  return {
    texts: [
      {
        text: props.text,
        options: {
          ...notesOptions,
          ...props.options,
        },
      },
    ],
  };
};
